export default {
  gridGap: '0rem 1rem',
  addButtonBg: '#DF0271',
  addButtonColro: 'var(--white)',
};
